export default __webpack_public_path__ + "static/media/dvds.7b230642.jpg";